import React, { useState } from 'react'
import { addSettlementAccount } from '../../../services/settings';
import toast from 'react-hot-toast';

const VerifyPopup = ({ isOpen, onClose, handleSubmit, data }) => {

    return (
        isOpen && (
            <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-black bg-opacity-50 z-50">

                <div className="bg-white rounded-lg p-8">

                    <section className='mb-4 flex flex-col gap-4'>
                        <div> <span className='font-bold'>Bank name: </span> {data.bankName}</div>
                        <div> <span className='font-bold'>Account Number:</span>  {data.accountNumber}</div>
                        <div> <span className='font-bold'> Account Name:</span> {data.accountName}</div>
                        <div> <span className='font-bold'>BVN: </span> {data.bvn}</div>
                        <div> <span className='font-bold'> Country:</span> {data.selectedCountry}</div>
                        <div> <span className='font-bold'>Account currency:</span>  {data.currencyName}</div>
                    </section>

                    <div className="flex gap-4 mt-10 justify-center">

                        <button
                            type="button"
                            className="bg-orange-400 px-8 text-white py-2 mr-2 rounded-md"
                            onClick={handleSubmit}
                        >
                            Add Account
                        </button>
                        <button
                            className="px-8 text-orange-400 border border-orange-400 p-2 rounded-md"
                            onClick={onClose}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </div>
        )
    )
}

export default VerifyPopup
